import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

import type { ClientViewMode } from "@/components/clients";
import { useClientBasePath } from "@/hooks/use-client-base-path";

/**
 * Shared Presenter / Visitor mode.
 * `/client` is always Visitor (no toggle).
 * On `/presenter`, selecting Visitor navigates to the mirrored `/client` path.
 */
export function useClientViewMode(): [
  ClientViewMode,
  (mode: ClientViewMode) => void,
] {
  const basePath = useClientBasePath();
  const navigate = useNavigate();
  const location = useLocation();

  const setViewMode = useCallback(
    (mode: ClientViewMode) => {
      if (basePath !== "/presenter" || mode !== "visitor") return;
      const suffix = location.pathname.slice("/presenter".length);
      navigate(`/client${suffix}${location.search}${location.hash}`);
    },
    [basePath, navigate, location.pathname, location.search, location.hash],
  );

  if (basePath === "/client") {
    return ["visitor", setViewMode];
  }

  return ["presenter", setViewMode];
}
